<template>
  <div>
    <div class="query-builder" v-if="localValue instanceof Object && !Array.isArray(localValue)">
      <div class="rules-group-container_">
        <div class="rules-group-body_">
          <div class="rules-list_">

            <component v-for="(field, key) in localValue" :key="key" :is="field.type" v-model="localValue[key]"
              :languages="languages"
              :value="field" :index="key" @save="save"/>

            <br />
          </div>
        </div>
      </div>

      <v-btn v-if="clearDatamap" class="ma-2" color="error" @click="clear"> <v-icon>mdi-delete</v-icon>Clear
        Datamap</v-btn>

    </div>
    <div v-if="!value && clearDatamap">
      <v-btn class="ma-2" color="primary" @click="override">
        Open Datamap
      </v-btn>
    </div>
  </div>
</template>

<script>
// let { getDetail } = require("@/api/base_entity");


export default {
  props: {
    value: { type: [Object, Array], default: null },
    config: { type: [Object, Array], default: null },
    entity: { type: String, default: null },
    entityId: { type: [String, Number], default: null },
    clearDatamap: { type: Boolean, default: true },
    languages: { type: Array, default: () => ["EN", "IT", "DE", "FR", "ES"] }
  },
  data() {
    return {
      localValue: this.value
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue
      },
      deep: true
    }
  },
  methods: {
    updateValue(index, newValue) {
      console.log(`DATAMAP --> Updating child ${index} with:`, newValue);

      // Usa Vue.set per assicurare la reattività
      this.$set(this.localValue, index, newValue);

      // Oppure sostituisci l'intero array
      // const updated = [...this.localValue];
      // updated[index] = newValue;
      // this.localValue = updated;
    },
    async clear() {
      const ret = await this.$root.$confirm.open('Confirm removal', 'Are you sure to remove this Datamap?', { color: 'red' })
      if (ret) {
        if (this.config) {
          this.localValue = this.config
          this.$emit("input", this.config);
          // this.$emit("inputObj", this.config);
        } else {
          this.localValue = null;
          this.$emit("input", null);
          // this.$emit("inputObj", null);
        }
        this.$forceUpdate();
      }
    },
    override() {
      this.localValue = this.config ? this.config : {};
      this.$emit("input", this.localValue);
      // this.$emit("inputObj", {});
    },
    save() {
      this.$emit('save', this.localValue)
    }
  },
}
</script>



<style>
/*!
 * jQuery QueryBuilder 2.5.2
 * Copyright 2014-2018 Damien "Mistic" Sorel (http://www.strangeplanet.fr)
 * Licensed under MIT (https://opensource.org/licenses/MIT)
 */
.query-builder .rule-container,
.query-builder .rule-placeholder,
.query-builder .rules-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #eee;
  background: rgba(255, 255, 255, 1);
  /* box-shadow: 1px 1px 5px 1px #8e8e8e; */
}

.query-builder .timepoint-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  /* border: 1px solid #ffbcbc; */
  background: rgba(242, 242, 242, 1);
  /* box-shadow: 1px 1px 5px 1px #8e8e8e; */
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.query-builder .drag-handle,
.query-builder .error-container,
.query-builder .rule-container .rule-filter-container,
.query-builder .rule-container .rule-operator-container,
.query-builder .rule-container .rule-value-container {
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
}

.query-builder .rules-group-container {
  /* padding: 10px;
  padding-bottom: 6px; */
  /* border: 1px solid #dcc896; */
  background: rgba(255, 252, 245, 0.5);
}

.query-builder .rules-group-header {
  margin-bottom: 10px;
}

.query-builder .rules-group-header .group-conditions .btn.readonly:not(.active),
.query-builder .rules-group-header .group-conditions input[name$="_cond"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
}

.query-builder .rules-group-header .group-conditions .btn.readonly {
  border-radius: 3px;
}

.query-builder .rules-list {
  list-style: none;
  padding: 0 0 0 15px;
  margin: 0;
}

.query-builder .rule-value-container {
  border-left: 1px solid #ddd;
  padding-left: 5px;
  width: 300px;
}

.query-builder .rule-value-container label {
  margin-bottom: 0;
  font-weight: 400;
}

.query-builder .rule-value-container label.block {
  display: block;
}

.query-builder .error-container {
  display: none;
  cursor: help;
  color: red;
}

.query-builder .has-error {
  background-color: #fdd;
  border-color: #f99;
}

.query-builder .has-error .error-container {
  display: inline-block !important;
}

/* .query-builder .rules-list > ::after,
.query-builder .rules-list > ::before {
  content: "";
  position: absolute;
  left: -10px;
  width: 10px;
  height: calc(50% + 4px);
  border-color: #ccc;
  border-style: solid;
} */

/* .query-builder .rules-list > ::before {
  top: -4px;
  border-width: 0 0 2px 2px;
} */

.query-builder .rules-list> ::after {
  top: 50%;
  border-width: 0 0 0 2px;
}

/* .query-builder .rules-list > :first-child::before {
  top: -12px;
  height: calc(50% + 14px);
}

.query-builder .rules-list > :last-child::before {
  border-radius: 0 0 0 4px;
} */

.query-builder .rules-list> :last-child::after {
  display: none;
}

.query-builder.bt-checkbox-glyphicons .checkbox input[type="checkbox"]:checked+label::after {
  font-family: "Glyphicons Halflings";
  content: "\e013";
}

.query-builder.bt-checkbox-glyphicons .checkbox label::after {
  padding-left: 4px;
  padding-top: 2px;
  font-size: 9px;
}

.query-builder .error-container+.tooltip .tooltip-inner {
  color: #f99 !important;
}

.query-builder p.filter-description {
  margin: 5px 0 0 0;
  background: #d9edf7;
  border: 1px solid #bce8f1;
  color: #31708f;
  border-radius: 5px;
  padding: 2.5px 5px;
  font-size: 0.8em;
}

.query-builder .rules-group-header [data-invert] {
  margin-left: 5px;
}

.query-builder .drag-handle {
  cursor: move;
  vertical-align: middle;
  margin-left: 5px;
}

.query-builder .dragging {
  position: fixed;
  opacity: 0.5;
  z-index: 100;
}

.query-builder .dragging::after,
.query-builder .dragging::before {
  display: none;
}

.query-builder .rule-placeholder {
  border: 1px dashed #bbb;
  opacity: 0.7;
}

.pull-right {
  float: right !important;
}

.has-error {
  background-color: #fdd;
  border-color: #f99;
}
</style>